import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { SubprocessenForEntity } from '../types/SubprocessenForEntity'

export { fetchSubprocessenForEntity, initialData }

const fetchSubprocessenForEntity = async ({ id, type }: Entity) => {
  const { data } = await apiClient({
    url: `/rest/${type}/${id}/subproces`,
    method: 'GET',
  })
  return data
}

const initialData: SubprocessenForEntity = {
  data: [],
}
